import React, { FC, memo } from 'react';
import Link from 'next/link';
import Widget from '@views/components/widget/Widget';
import HorizontalCarousel from '@views/components/carousels/HorizontalCarousel';
import LazyImage from '@views/components/lazy-image';
import Placeholder from './placeholder';

import { ICategory } from '@server/data/models/category';
import { INTERNAL_URI, categoryHref } from '@helpers/route';
import _chunk from 'lodash/chunk';
import _get from 'lodash/get';
import _truncate from 'lodash/truncate';
// import useCategory from '@hooks/use-category';
import { useCategoryQuery } from 'src/generated/graphql';

import cn from 'classnames';
import {
  EVENT_CLASS_NAME,
  EVENT_ACTION_NAME,
  EVENT_CATEGORY,
  EVENT_LABEL,
} from '@helpers/events';

const CategoryList = memo<{ data: any }>(({ data }) => (
  <HorizontalCarousel id="__categoryList__" contentClassName="widget__group">
    {data.map((item: ICategory, rootIndex) => (
      <Widget.GroupItem
        key={`category-root-${_get(item, 'id') || rootIndex}`}
        v3
      >
        <Link
          key={`category-item-${_get(item, 'id')}`}
          href={INTERNAL_URI.CATEGORY}
          as={categoryHref(_get(item, 'id'), _get(item, 'urlKey'))}
        >
          <a
            aria-label={_get(item, 'name')}
            title={_get(item, 'name')}
            className={cn(EVENT_CLASS_NAME)}
            data-category={EVENT_CATEGORY.CATEGORY_CHILD_DETAIL}
            data-action={EVENT_ACTION_NAME}
            data-label={_get(item, 'name')}
          >
            <LazyImage
              src={_get(item, 'imageIcon') || '/assets/icon/categories.png'}
              alt={_get(item, 'name')}
              className="widget__image widget__image--v2"
              placeholder="/assets/icon/categories.png"
            />
            <span className="text-center">
              {_truncate(_get(item, 'name'), { length: 35 })}
            </span>
          </a>
        </Link>
        )
      </Widget.GroupItem>
    ))}
  </HorizontalCarousel>
));
CategoryList.displayName = 'CategoryList';

// const getList = (data: Array<ICategory>, id: number) => {
//   const category = data.find((item: any) => _get(item, 'id') == id);
//   const path = _get(category, 'path');

//   const [, level1, level2, level3] = (path || '')
//     .split('/')
//     .map((id: string) => parseInt(id));

//   let parentId = id;
//   if (level2 == id) {
//     parentId = level1;
//   } else if (level2 == 3) {
//     parentId = level2;
//   }

//   return data.filter((item: any) => _get(item, 'parentId') == parentId);
// };

interface Props {
  categoryId: number;
}

export const Container: FC<Props> = memo<Props>(({ categoryId }) => {
  // const { loading, error, categories } = useCategory();
  const { loading, error, data } = useCategoryQuery({
    variables: {
      page: 1,
      limit: 100,
      parentId: categoryId,
    },
  });

  if (loading || error) {
    return <Placeholder />;
  }

  // @ts-ignore
  // const data = getList(categories, categoryId);

  return (
    <Widget grid brand>
      {/* <Widget.Title as="h1" style={{ color: 'var(--gray-dark)' }}>
        DANH MỤC
      </Widget.Title> */}
      <CategoryList data={_get(data, 'categories', [])} />
    </Widget>
  );
});
Container.displayName = 'CategoryListContainer';

export default Container;
